import { Inbox } from 'lucide-react'
import { VeraAvatar } from '@/components/compliance/VeraAvatar'
import { cn } from '@/lib/utils'

/** Matches InboxPage shell: 50px MainHeader + 42px list tab row. */
export const INBOX_LIST_EMPTY_MIN_HEIGHT_CLASS =
  'min-h-[calc(var(--app-vh)_-_50px_-_42px)]'

export function InboxListEmptyState({
  variant,
  description,
  className,
}: {
  variant: 'notifications' | 'requests'
  description: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-4 text-center',
        INBOX_LIST_EMPTY_MIN_HEIGHT_CLASS,
        className,
      )}
    >
      {variant === 'notifications' ? (
        <VeraAvatar size={40} showBadge={false} />
      ) : (
        <Inbox className='h-10 w-10 text-text-disabled' strokeWidth={1.5} />
      )}
      <p className='mt-4 font-heading text-[13px] font-medium text-text-secondary'>
        All caught up
      </p>
      <p className='mt-1 max-w-[260px] text-[12px] leading-relaxed text-text-subtle'>
        {description}
      </p>
    </div>
  )
}
